import React, {useEffect, useRef, useState} from "react";
import Icon from "../../Icon/Icon";
import {InfiosArrowWrapper, InfiosDropdown, InfiosDropdownWrapper, InfiosOption} from "./Dropdown.style";
import {InfiosContainedDropdownLabel} from "../Label/ContainedLabel.style";

const Dropdown = (props) => {
    const { labelText, className, id, disabled, name, errorMessage, required, options, value, invalid, errorHandler, onChange, validate, defaultValue, useLabelAsValue, hasInvalidValue, invalidValue, firstOptionDisabled, inputRef } = props;

    const containerRef  = useRef(null);
    const [height, setHeight] = useState(0);
    const [error, setError] = useState(false);
    const [selectedValue, setSelectedValue] = useState("");

    useEffect(() => {
        setHeight(containerRef.current.offsetHeight);
        setError(invalid);
    }, [invalid]);

    useEffect(() => {
        if (selectedValue) {
            setError(false)
        }
    }, [selectedValue]);

    const shouldBlur = (e) => {
        e.target.blur();
    }

    const handleError = (event) => {
        if(errorHandler) setError(errorHandler(event));
        if(onChange) onChange(event);
        if(validate) validate(event.target.value);
        shouldBlur(event);
        setSelectedValue(event.target.value);
    };

    const handleChange = (event) => {
        const current = event.target.value;
        setSelectedValue(current);
      };

    const createOption = option => {
        if (option.value === "empty") return "";

        if(useLabelAsValue) return option.label;

        return option.value
            ? option.value
            : option.label.split(',')[0].replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }

    return (
        <InfiosDropdownWrapper ref={containerRef} selectedValue={selectedValue}>
            <InfiosDropdown
                className={`p-regular ${error ? 'error' : ''} ${className ? className : ''}`}
                name={name}
                disabled={disabled}
                value={value}
                id={id}
                defaultValue={defaultValue || ''}
                required={required}
                ref={inputRef}
                onChange={handleError}
            >
                <option disabled value="">{labelText}{required ? ' *' : ''}</option>
                {hasInvalidValue && <InfiosOption value="" disabled>{invalidValue}</InfiosOption>}
                {options?.map((option, index) => (
                    <InfiosOption
                        key={`${createOption(option)}-${index}`}
                        value={createOption(option)}>
                        {option.label}
                    </InfiosOption>
                ))}
            </InfiosDropdown>
            <InfiosContainedDropdownLabel
                htmlFor={name}
                required={required}
                disabled={disabled}>
                {labelText}{required ? ' *' : ''}
            </InfiosContainedDropdownLabel>
            <InfiosArrowWrapper containerHeight={height}>
                <Icon icon="chevron-dropdwon" />
            </InfiosArrowWrapper>
            {errorMessage && <span className="label-small">{errorMessage || "Error"}</span>}
        </InfiosDropdownWrapper>
    )
}

export default Dropdown;
